import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useAuth } from "../contexts/AuthContext";
import { dashboardMenu } from "../data/Menu";
import logoCere from "../assets/img/logo.png";

const Sidebar = () => {
  const { user, isAuthenticated, loading: authLoading, logout } = useAuth();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);
  const [userName, setUserName] = useState("Administrateur");
  const [userRole, setUserRole] = useState("Administrateur");

  // Redirection si non connecté
  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      setRedirecting(true);
      navigate("/login");
    }
  }, [isAuthenticated, authLoading, navigate]);

  // Mise à jour du nom/rôle quand l'utilisateur change dans le contexte
  useEffect(() => {
    if (user) {
      setUserName(user.name || user.email?.split("@")[0] || "Administrateur");
      setUserRole(user.role === "admin" ? "Administrateur" : "Éditeur");
    }
  }, [user]);

  const toggleFooterMenu = (e) => {
    e.preventDefault();
    const parent = e.target.closest(".sidebar");
    if (parent) parent.classList.toggle("footer-menu-show");
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  if (redirecting || authLoading) {
    return (
      <div
        className="sidebar"
        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <div className="spinner-border" style={{ color: "#009e60" }} role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="sidebar">
      {/* --- Logo CERE --- */}
           {/* --- Logo CERE --- */}
      <div className="sidebar-header">
        <Link to="/dashboard" className="sidebar-logo">
          <img src={logoCere} alt="CERE Gabon" className="sidebar-logo-img" />
        </Link>
      </div>

      {/* --- Menu --- */}
      <PerfectScrollbar className="sidebar-body">
        <SidebarMenu />
      </PerfectScrollbar>

      {/* --- Footer utilisateur --- */}
      <div className="sidebar-footer">
        <div className="sidebar-footer-top">
          {/* Avatar à initiale */}
          <div className="sidebar-footer-thumb">
            <div className="cere-sidebar-avatar">
              {userName.charAt(0).toUpperCase()}
            </div>
            <div className="status-indicator bg-success"></div>
          </div>

          {/* Nom + rôle */}
          <div className="sidebar-footer-body">
            <h6 className="mb-0">
              <Link
                to="/profile"
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                {userName}
              </Link>
            </h6>
            <span className="cere-sidebar-role">
              <i className="ri-shield-user-line me-1"></i>
              {userRole}
            </span>
          </div>

          {/* Bouton pour ouvrir le menu déroulant */}
          <Link onClick={toggleFooterMenu} to="#" className="dropdown-link">
            <i className="ri-arrow-down-s-line"></i>
          </Link>
        </div>

        {/* Menu déroulant (profil / statistiques / déconnexion) */}
        <div className="sidebar-footer-menu">
          <nav className="nav flex-column">
            <Link to="/profile" className="nav-link">
              <i className="ri-user-line me-2"></i>Mon profil
            </Link>
            <Link to="/statistics" className="nav-link">
              <i className="ri-bar-chart-box-line me-2"></i>Statistiques
            </Link>

             <Link to="/dashboard" className="nav-link">
              <i className="ri-bar-chart-box-line me-2"></i>Tableau de bord
            </Link>
          </nav>

          <hr className="my-2" />
          <br></br>
           <br></br> <br></br> 

          <nav className="nav flex-column">
            <button
              onClick={handleLogout}
              className="nav-link text-danger border-0 bg-transparent text-start"
            >
              <i className="ri-logout-box-r-line me-2"></i>Déconnexion
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// SidebarMenu — affiche les items du menu principal
// ============================================================
const SidebarMenu = () => {
  return (
    <>
      {dashboardMenu.map((item) => (
        <div className="nav-group" key={item.label}>
          {item.submenu ? (
            <>
              <div className="nav-label text-white">
                <i className={`${item.icon} me-2`}></i>
                {item.label}
              </div>
              <ul className="nav nav-sidebar">
                {item.submenu.map((sub, i) => (
                  <li key={i} className="nav-item">
                    <NavLink
                      to={sub.link}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className={sub.icon}></i>
                      <span>{sub.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <NavLink
              to={item.link}
              className={({ isActive }) =>
                isActive
                  ? "nav-label nav-label-clickable text-white active"
                  : "nav-label nav-label-clickable text-white"
              }
            >
              <i className={`${item.icon} me-2`}></i>
              {item.label}
            </NavLink>
          )}
        </div>
      ))}
    </>
  );
};

export default Sidebar;